import { defineStore } from 'pinia'

export type ThemeMode = 'light' | 'dark'

export const useThemeStore = defineStore('theme', {
  state: () => ({
    mode: 'light' as ThemeMode,
    isInitialized: false
  }),
  
  getters: {
    isDark: (state) => state.mode === 'dark',
    isLight: (state) => state.mode === 'light',
    themeClass: (state) => `theme-${state.mode}`
  },
  
  actions: {
    setMode(mode: ThemeMode) {
      this.mode = mode
      this.applyTheme()
    },
    
    toggleMode() {
      this.mode = this.mode === 'light' ? 'dark' : 'light'
      this.applyTheme()
    },
    
    initializeFromUrl(mode?: string) {
      if (mode && (mode === 'light' || mode === 'dark')) {
        this.mode = mode
      } else {
        // Default to light mode if no valid mode is provided
        this.mode = 'light'
      }
      this.applyTheme()
      this.isInitialized = true
    },
    
    applyTheme() {
      // Remove existing theme classes
      document.documentElement.classList.remove('theme-light', 'theme-dark')
      // Add current theme class
      document.documentElement.classList.add(`theme-${this.mode}`)
      
      // Update body class for additional styling if needed
      document.body.classList.remove('theme-light', 'theme-dark')
      document.body.classList.add(`theme-${this.mode}`)
    }
  }
})
